import { Component, input, InputSignal } from '@angular/core';
import { IEventNotificationModel } from '../event-notification.model';
import { TranslatePipe } from '@ngx-translate/core';
import { TimeUnitConverterPipe } from '../../../shared/pipes/time-unit-converter.pipe';

@Component({
    selector: 'phar-event-notification-header',
    templateUrl: 'event-notification-header.component.html',
    styleUrl: 'event-notification-header.component.scss',
    imports: [TranslatePipe, TimeUnitConverterPipe],
})
export class EventNotificationHeaderComponent {
  notification: InputSignal<IEventNotificationModel> = input<IEventNotificationModel>();
}
